module.exports = __webpack_public_path__ + "img/man-at-office.16252e23.jpeg";